<template>
  <router-link to="/mi-feed"
    ><img
      class="img-fluid for-light"
      src="@/assets/images/logo/logo.png"
      alt=""
  /></router-link>
</template>
